import $ from 'jquery';

const addSuccessMessage = (message, append = false) => {
    const successHTML = $.parseHTML(`<div class="success-message"><div class="message-text">${message}</div><button class="close-message" type="button">&times;</button></div>`);
    if (append) {
        return $('.messages').append(successHTML);
    }
    return $('.messages').empty().append(successHTML);
};

const addErrorMessage = (message, append = false) => {
    const errorHTML = $.parseHTML(`<div class="error-message"><div class="message-text">${message}</div><button class="close-message" type="buttom">&times;</button></div>`);
    if (append) {
        return $('.messages').append(errorHTML);
    }
    return $('.messages').empty().append(errorHTML);
};

const removeMessage = () => $('.messages').empty();

export { addSuccessMessage, addErrorMessage, removeMessage };
